import React, { useEffect, useState } from "react";
import {
    TableHead,
    TableBody,
    Table,
    TableContainer,
    TableCell,
    TableRow,
    Box,
    TablePagination,
    Pagination,
    Button,
    TextField,
    Typography,
    InputAdornment,
    MenuItem,
    Menu,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getListOfLoansToApprove, loanApprove, loanCancel, loanRequestCancel, loansUpdateRequestStatus } from "../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";

import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import CustomInputAlert from "../UI/CustomInputAlert/CustomInputAlert";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";

const UnderwritingCreditAssessment = ({
    setViewUnderwritingCreditAssessment,
    selectedProductLoan,
    selectedUser,
    setAlert,
    getProductsAssignedToUsers,
    setAlertOpen
}) => {
    const [searchText, setSearchText] = useState("");
    const [loanList, setLoanList] = useState([]);
    const [allLoans, setAllLoans] = useState([]);
    // const [showInputAlert, setShowInputAlert] = useState(false);
    const [showInputAlert, setShowInputAlert] = useState({
        showAlert: false,
        severity: "",
        header: "",
        message: "",
        onConfirm: null,
        alertType: "",
        inputLabel:""
      });
    const [selectedLoan, setSelectedLoan] = useState(null);
    const authUser = sessionStorage.getItem("user");
    const parsedAuthUser = JSON.parse(authUser);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor: "rgba(0,0,0, .1)",
        color: theme.palette.common.black,
        fontWeight: "bold",
        textAlign: "left",
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 25,
        fontWeight: "600",
        },
    }));

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    }

    useEffect(()=> {
        getLoansList();
    },[selectedUser, selectedProductLoan]);

    const getLoansList = async() => {
        try {
            const response = await getListOfLoansToApprove(350, `${selectedUser}/${selectedProductLoan?.productcode}`);
            // const response = await getListOfLoansToApprove(229, `${selectedUser}/${selectedProductLoan?.productcode}`);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanProductsArray = Array.isArray(response?.data?.body?.record)
                  ? response?.data?.body?.record
                  : [response?.data?.body?.record];
                
                console.log("getLoansList_loanProductsArray=======================",loanProductsArray);
                setLoanList(loanProductsArray);
                setAllLoans(loanProductsArray);
            } else if(response?.data?.header?.reccount === "0") {
                setLoanList([]);
                setAllLoans([]);
            }
        } catch (error) {
            console.log("getLoansList_error=======================",error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleLoanApproval = async(comment, rowData) => {
        try {
            const response = await loansUpdateRequestStatus("", rowData?.loanrequests?.requestid, 5);
            if(response?.data?.header?.callStatus === "1" ) {
                getLoansList();
                setAlert({
                    showAlert: true,
                    severity: "success",
                    message: "Loan assessment done successfully.",
                    header: "Congratulations!",
                });
                setAlertOpen(true);
                getLoansList()
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                severity: "error",
                message: "Failed to approve loan.",
                header: "Error!",
            });
            console.log("handleLoanApproval_error=======================",error);
        }
    }

    const handleLoanCancellation = async(reason, rowData) => {
        try {
            console.log("selectedLoan=======================",rowData?.loanrequests?.requestid);
            console.log("handleLoanRequestCancellation=======================",reason);
            const response = await loanRequestCancel("", rowData?.loanrequests?.requestid);
            console.log("handleLoanCancellation_response=======================",response);
            if(response?.data?.header?.callStatus === "1") {
                getLoansList();
                setAlert({
                    showAlert: true,
                    severity: "success",
                    message: "Loan request cancelled successfully.",
                    header: "Congratulations!",
                });
                setAlertOpen(true);
                getProductsAssignedToUsers();
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                severity: "error",
                message: "Failed to cancel loan.",
                header: "Error!",
            });
            console.log("handleLoanCancellation_error=======================",error);
        }
    }

    const approveLoanConfirmation = async(rowData) => {
        console.log("approveLoanConfirmation=======================",rowData);
        setSelectedLoan(rowData);
        setShowInputAlert((prevState) => ({
            ...prevState,
            showAlert: true,
            severity: "confirm",
            message: "Are you sure you want to approve this loan assessment?",
            header: "Confirm Loan Assessment",
            alertType: "confirm",
            inputLabel: "Comment",
            onConfirm: (comment) => {
                handleLoanApproval(comment, rowData);
            },
        }));
    }

    const cancelLoanConfirmation = async(rowData) => {
        setSelectedLoan(rowData);
        setShowInputAlert((prevState) => ({
            ...prevState,
            showAlert: true,
            severity: "confirm",
            message: "Are you sure you want to cancel this loan request?",
            header: "Cancel Loan Request?",
            alertType: "confirm",
            inputLabel: "Reason",
            onConfirm: (reason) => {
                handleLoanCancellation(reason, rowData); // Pass rowData directly
            },
        }));
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = () => {
        console.log("handleSearch===========",searchText);
        if (!searchText.trim()) {
            setLoanList(allLoans); // Reset to original data if search is cleared
            return;
        }
    
        const filteredLoans = allLoans.filter((row) => {
            return (
                row?.loanproducts?.loanproductname?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loantypes?.loandesc?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanrequests?.requestamount?.toString().includes(searchText) ||
                row?.loanrequests?.requestdate?.toLowerCase().includes(searchText.toLowerCase())
            );
        });
    
        setLoanList(filteredLoans);
    }

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const handleViewDetails = (loan) => {
        setSelectedLoan(loan);
        // setOpenDetailsDialog(true);
        setOpenDetailsDrawer(true);
        handleMenuClose(); // close the menu
    };

    return (
        <Box className="loan-assignment-container">
            {
            isLoading ? 
                    (
                        <div className="text-center mt-5">
                            <span className="loader" />
                        </div>
                    ) :
            <>
                <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                    Underwriting & Credit Assessment
                    </Typography>
                    <Box>
                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => setViewUnderwritingCreditAssessment(false)}
                    >
                        Return
                    </Button>
                    </Box>
                </Box>

                <Box>
                    <Box className="search-container">
                    <TextField
                        placeholder="Search by Product name, Requested amount, etc."
                        value={searchText}
                        onChange={handleInputChange}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                handleSearch(); 
                            }
                        }}
                        variant="standard"
                        fullWidth
                        InputProps={{
                            disableUnderline: true,
                            sx: {
                                borderRadius: "33px",
                                color: "#000",
                            },
                            endAdornment: (
                                <InputAdornment position="end">
                                <IconButton onClick={handleSearch} edge="end">
                                    <SearchIcon />
                                </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            "& .MuiInputBase-root": {},
                            "& .MuiInputBase-input": {
                                fontSize: "14px",
                            },
                        }}
                    />
                    </Box>
                </Box>

                <Box className="mt-4">
                    <TableContainer className="loan-approve-table-container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Product Name</StyledTableCell>
                                    <StyledTableCell>Loan Desc</StyledTableCell>
                                    <StyledTableCell sx={{ textAlign:"right !important" }}>Requested Amount</StyledTableCell>
                                    <StyledTableCell>Request Date</StyledTableCell>
                                    <StyledTableCell>Comments</StyledTableCell>
                                    <StyledTableCell>Action</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {
                                loanList && loanList.length > 0 ? (
                                    loanList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="left" className="">
                                                <div>{row?.loanproducts?.loanproductname}</div>
                                            </TableCell>
                                            <TableCell align="left" className="">
                                                <div>{row?.loantypes?.loandesc}</div>
                                            </TableCell>
                                            <TableCell align="right" className="">
                                                <div>{Number(row?.loanrequests?.requestamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                            </TableCell>
                                            <TableCell align="left" className="">
                                                <div>{row?.loanrequests?.requestdate}</div>
                                            </TableCell>
                                            <TableCell align="left" className="">
                                                <div>{row?.loanrequests?.comments}</div>
                                            </TableCell>
                                            <TableCell>
                                                <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                                    <MoreVertIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell align="center" colSpan={4}>
                                            <Typography variant="body1" color="textSecondary">
                                            No data available
                                            </Typography>
                                        </TableCell>
                                        </TableRow>
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20]}
                        component="div"
                        count={loanList.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                        <MenuItem
                            disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                            onClick={() => {
                                approveLoanConfirmation(selectedLoan)
                                handleMenuClose();
                            }}
                        >
                            Approve Request
                        </MenuItem>
                        {/* <MenuItem
                            disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                            onClick={() => {
                                cancelLoanConfirmation(selectedLoan)
                                handleMenuClose();
                            }}
                        >
                            Cancel Request
                        </MenuItem> */}
                        <MenuItem
                            disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                            onClick={() => {
                                handleViewDetails(selectedLoan)
                                handleMenuClose();
                            }}
                        >
                            View Details
                        </MenuItem>
                    </Menu>
                </Box>
            </>
            }

            <CustomInputAlert
                show={showInputAlert?.showAlert}
                severity={showInputAlert?.severity}
                header={showInputAlert?.header}
                message={showInputAlert?.message}
                alertType={showInputAlert?.alertType}
                inputLabel={showInputAlert?.inputLabel}
                confirmButton={(value) => showInputAlert?.onConfirm(value)} 
                // confirmButton={(value) => handleLoanApproval(value)} 
                onClick={() => setShowInputAlert(false)}
                hideInput={true}
            />

            <div className="loans-details-info-drawer">
                <BaseDrawer
                    open={openDetailsDrawer}
                    handleClose={() => setOpenDetailsDrawer(false)}
                    height="85vh"
                    className="loanProductInfoDrawer"
                    overflow="auto"
                >
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                        {/* Left: Loan Info */}
                                        <Box className="mb-4" flex={1}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    color: "#6b7280",
                                                    fontFamily: "Nunito",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                }}
                                            >
                                                Loan Request Info
                                            </Typography>
                                            <Box className="info-container">
                                                <Box className="info-type">Request ID:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.requestid}
                                                </Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">User ID:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.userid}
                                                </Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Request Date:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.requestdate}
                                                </Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Request Amount:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.requestamount}
                                                </Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Current Limit:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.currentlimit}
                                                </Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Outstanding Loan:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.currentoutstandingloan}
                                                </Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Issued:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.issued == "-2" ? "Pending" : selectedLoan?.loanrequests?.issued == "1" ? "Issued" : "N/a"}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">External Ref No:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.externalrefno}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Comments:</Box>
                                                <Box className="info-response">
                                                {selectedLoan?.loanrequests?.comments}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Amount for Fee Calculation:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.amountforfeecalculation}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Approved Date:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.approveddate || 'N/A'}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Approved By:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.approvedby}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Overridden Interest Amount:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.overriddeninterestamount}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Override Interest:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.overrideinterest}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Other Details:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.otherdetails || 'N/A'}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Term Type:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.termtype}
                                                </Box>
                                            </Box>

                                            <Box className="info-container">
                                                <Box className="info-type">Last Execution Time:</Box>
                                                <Box className="info-response">
                                                    {selectedLoan?.loanrequests?.lastexecutiontime || 'N/A'}
                                                </Box>
                                            </Box>
                                        </Box>

                                        <Box flex={1}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    color: "#6b7280",
                                                    fontFamily: "Nunito",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                }}
                                                className=""
                                        
                                            >
                                                Loan Product & Type Info
                                            </Typography>

                                            <Box className="">
                                                <Box className="info-container">
                                                    <Box className="info-type">Loan Product:</Box>
                                                    <Box className="info-response">
                                                        {selectedLoan?.loanproducts?.loanproductname}
                                                    </Box>
                                                </Box>
                                                <Box className="info-container">
                                                    <Box className="info-type">Currency Code:</Box>
                                                    <Box className="info-response">
                                                        {selectedLoan?.loanproducts?.currencycode}
                                                    </Box>
                                                </Box>
                                                <Box className="info-container">
                                                    <Box className="info-type">Loan Type:</Box>
                                                    <Box className="info-response">
                                                        {selectedLoan?.loantypes?.loandesc}
                                                    </Box>
                                                </Box>
                                                
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </BaseDrawer>
            </div>
        </Box>
    );
};

export default UnderwritingCreditAssessment;